<script setup lang="ts">
import AppNavbarLinkItems from "@/App/components/AppNavbar/AppNavbarLinkItems.vue";
</script>

<template>
  <ul class="app-navbar-links navbar-nav">
    <AppNavbarLinkItems />
  </ul>
</template>

<style lang="scss" scoped>
.app-navbar-links {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  .nav-link {
    color: var(--bs-gray-500);
    transition: all 0.3s ease;
    &:focus,
    &:hover {
      color: var(--bs-gray-100);
    }
  }
}
@media (max-width: 47.25rem) {
  .app-navbar-links {
    display: none;
  }
}
</style>
